import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings -> Easeedesk -> Planning (v4/api, `App\Settings\Easeedesk\
 * EaseedeskPlanning`). Forma paginii e inghetata in
 * `settings/easeedesk/__fixtures__/planningSettings.json`.
 */
export interface PlanningTicketType {
  ID: number
  type_name: string
  short_name: string
  color_identifier: string
  checked: number
}

export interface PlanningPage {
  ticket_types: PlanningTicketType[]
  settings: { planning_color: string; stop_sla: number }
}

export function planningSettingsQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'planning'],
    queryFn: () => apiGet<PlanningPage>('/settings/easeedesk/planning_settings'),
  })
}

/**
 * `Easeedesk::save_ticket_planning_settings`, cu campurile formularului vechi:
 * `ticket_types[id][id]`, `ticket_types[id][status]=on` numai pe cele bifate,
 * `settings[color]`, `settings[stop_sla]=on` numai cand e bifat.
 */
export function savePlanningSettings(checked: Record<number, boolean>, color: string, stopSla: boolean) {
  const fields: Record<string, string> = {}
  for (const [id, on] of Object.entries(checked)) {
    fields[`ticket_types[${id}][id]`] = id
    if (on) fields[`ticket_types[${id}][status]`] = 'on'
  }
  fields['settings[color]'] = color
  if (stopSla) fields['settings[stop_sla]'] = 'on'
  return apiPost<{ status: string }>('/settings/easeedesk/planning_settings', fields)
}

/** `Easeedesk::rebuild_resume_planning_configuration` - butonul "Refresh cron". */
export function rebuildPlanningCron() {
  return apiPost<{ result: 'done' | 'failed'; action: string; message?: string }>('/settings/easeedesk/planning_settings/rebuild', {})
}
